export const A2S_OBJECT_KEY = "P_Login";

/**
 * 컨플 문서
 * https://confluence.nexon.com/pages/viewpage.action?pageId=2214854148
 */
export const A2S_LOG_ENTRIES = [
  ["LOGIN0001", "P_NexonLogin"],
  ["LOGIN0002", "Logo"],
  ["LOGIN0003", "Tab_NexonID"],
  ["LOGIN0004", "Tab_Onetime"],
  ["LOGIN0005", "Tab_QR"],
  ["LOGIN0006", "KeepLoggedin"],
  ["LOGIN0007", "NEXONID_Login"],
  ["LOGIN0008", "Join"],
  ["LOGIN0009", "IDSearch"],
  ["LOGIN0010", "PWSearch"],
  ["LOGIN0011", "Security"],
  ["LOGIN0012", "TPA_Facebook"],
  ["LOGIN0013", "TPA_Google"],
  ["LOGIN0014", "TPA_Naver"],
  ["LOGIN0015", "TPA_Apple"],
  ["LOGIN0016", "P_OnetimeLogin"],
  ["LOGIN0017", "OneTime_Login"],
  ["LOGIN0018", "NexonPlay_Info"],
  ["LOGIN0019", "P_RestrictedQR"],
  ["LOGIN0020", "P_FailQR"],
  ["LOGIN0021", "P_LoadingQR"],
  ["LOGIN0022", "P_QRLogin"],
  ["LOGIN0023", "P_RetryQR"],
  ["LOGIN0024", "QRAuthFail"],
  ["LOGIN0025", "QRIPMismatch"],
  // ["LOGIN0026", ""],
  ["LOGIN0027", "NexonPlay_Info"],
  ["LOGIN0028", "QR_Info"],
  ["LOGIN0029", "QR_Refresh"],
  ["LOGIN0030", "P_CaptchaLogin"],
  ["LOGIN0031", "TurnStile"],
  ["LOGIN0032", "P_LoginBlock"],
  ["LOGIN0033", "IdentityLogin"],
  ["LOGIN0034", "NEXONID_LoginSucces"],
  ["LOGIN0035", "ConversionBanner"],
] as const;
